import { carouselItems } from '@/mocks/homeData';

export default function CarouselSection() {
  return (
    <section id="carousel" className="py-14 md:py-20 bg-background-100">
      <div className="mx-auto max-w-[1440px] px-4 md:px-6">
        <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950 text-center mb-3">
          焦点推荐
        </h2>
        <p className="text-sm text-foreground-500 text-center mb-10">
          编辑精选当期最值得关注的漫画专题
        </p>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5">
          {carouselItems.map((item, i) => (
            <a
              key={i}
              href="#ranking"
              className="group block bg-background-50 rounded-xl border border-background-200/70 overflow-hidden cursor-pointer transition-all duration-200 hover:border-primary-300 hover:shadow-lg hover:shadow-primary-100/30"
            >
              <div className="relative w-full aspect-[8/5] overflow-hidden">
                <img
                  src={item.image}
                  alt={item.title}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-600"
                  loading={i === 0 ? undefined : 'lazy'}
                />
                <span className="absolute top-3 left-3 px-2.5 py-1 rounded-full bg-primary-500 text-white text-xs font-medium shadow-md">
                  {item.tag}
                </span>
                <div className="absolute inset-0 bg-gradient-to-t from-black/20 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300" />
              </div>
              <div className="p-4">
                <h3 className="text-base font-heading font-bold text-foreground-900 group-hover:text-primary-500 transition-colors mb-1.5">
                  {item.title}
                </h3>
                <p className="text-sm text-foreground-600 leading-relaxed line-clamp-2">
                  {item.desc}
                </p>
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}